import { render, staticRenderFns } from "./payControl.vue?vue&type=template&id=63917180&scoped=true&"
import script from "./payControl.vue?vue&type=script&lang=js&"
export * from "./payControl.vue?vue&type=script&lang=js&"
import style0 from "./payControl.vue?vue&type=style&index=0&id=63917180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63917180",
  null
  
)

export default component.exports